import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import pick from 'lodash/pick';

import {
  Input,
  Button,
} from '@pearsontechnology/aero-components';

import { ModalContent, ModalActions } from 'components/Modal';
import { intl } from 'containers/LanguageProvider/IntlGlobalProvider';
import { commandWorkspaceCreate } from 'containers/ConnectionManager/actions';

import {
  FormField,
} from './styles';
import messages from './messages';

class CreateWorkspaceModal extends React.Component {
  state = {
    name: '',
    description: '',
    nameFeedback: '',
    isValid: false,
  };

  onWorkspaceCreate = () => {
    const inputFields = pick(this.state, [
      'name',
      'description',
    ]);

    const { createWorkspace } = this.props;
    createWorkspace(inputFields);
  }

  checkFieldsNotEmpty = () => {
    const inputFields = pick(this.state, [
      'name',
    ]);

    const keys = Object.keys(inputFields);

    const isValid =
      keys.filter((key) =>
        this.state[key].length)
        .length === keys.length;

    this.setState({
      isValid,
    });
  }

  handleInputChange = (key, value) => {
    const inputFields = pick(this.state, [
      'name',
    ]);

    this.setState({
      [key]: value,
      [`${key}Feedback`]: (!value.length && key in inputFields) ? intl.formatMessage(messages[`${key}Feedback`]) : '',
    }, () => this.checkFieldsNotEmpty());
  }

  render() {
    return (
      <React.Fragment>
        <ModalContent>
          <FormField>
            <Input
              label={intl.formatMessage(messages.name)}
              onChange={(e) => this.handleInputChange('name', e.target.value.trim())}
              feedback={this.state.nameFeedback}
            />
          </FormField>
          <FormField>
            <Input
              label={intl.formatMessage(messages.description)}
              onChange={(e) => this.handleInputChange('description', e.target.value.trim())}
            />
          </FormField>
        </ModalContent>
        <ModalActions>
          <Button primary onClick={this.onWorkspaceCreate} disabled={!this.state.isValid}>{intl.formatMessage(messages.createWorkspace)}</Button>
        </ModalActions>
      </React.Fragment>
    );
  }
}

CreateWorkspaceModal.propTypes = {
  createWorkspace: PropTypes.func,
};

const mapDispatchToProps = (dispatch, ownProps) => ({
  createWorkspace: (workspace) => {
    const { onDismiss } = ownProps;
    const callbacks = [onDismiss];
    dispatch(commandWorkspaceCreate(workspace, {
      callbacks,
    }));
  },
});

export default connect(null, mapDispatchToProps)(CreateWorkspaceModal);
